// const CHART_URL = 'http://127.0.0.1:8787/api/chart';
const CHART_URL = 'https://crocpot.io/api/chart';

/**
 * In simulations this was always sufficient, but we will run a web3
 * estimate, and go 50% above the estimate. In addition we will bound
 * by the following range:
 */
export const GAS_LIMIT_MINIMUM = 255000; // highest recent mint was 212683
export const GAS_LIMIT_MAXIMUM = 500000;

/**
 * Percent of the median price to attempt to use.
 * 97 = 3% lower than the median
 */
export const GAS_PRICE_SUGGESTION = 98;

export const TOKEN_LIMIT = 1000;

// id color   name         cost   supply    value   value per pass
// 0  Blue    Exclusive     1 Ξ      990    990 Ξ   0.0583090379%
// 1  Gold    Premium      10 Ξ       10    100 Ξ   0.583090379%
// 2  Silver  Standard    0.5 Ξ      500    250 Ξ   0.02915451895%
// 3  Bronze  Basic      0.25 Ξ     1500    375 Ξ   0.01457725948%
//                                         1715 Ξ

// To match tokenization
export const TOKEN_NAMES = {
    0: 'EXCLUSIVE MEMBER',
    1: 'PREMIUM MEMBER',
    2: 'STANDARD MEMBER',
    3: 'BASIC MEMBER',
};

export const TOKEN_COLORS = {
    0: '#32D2B4',
    1: '#DDB962',
    2: 'rgba(255,255,255,0.8)',
    3: '#C8B89C',
};

export const SYMBOL_SVG = ['$pac','0xbtc','2give','aave','abt','act','actn','ada','add','adx','ae','aeon','aeur','agi','agrs','aion','algo','amb','amp','ampl','ankr','ant','apex','appc','ardr','arg','ark','arn','arnx','ary','ast','atm','atom','audr','auto','aywa','bab','bal','band','bat','bay','bcbc','bcc','bcd','bch','bcio','bcn','bco','bcpt','bdl','beam','bela','bix','blcn','blk','block','blz','bnb','bnt','bnty','booty','bos','bpt','bq','brd','bsd','bsv','btc','btcd','btch','btcp','btcz','btdx','btg','btm','bts','btt','btx','burst','bze','call','cc','cdn','cdt','cenz','chain','chat','chips','chsb','cix','clam','cloak','cmm','cmt','cnd','cnx','cny','cob','colx','comp','coqui','cred','crpt','crv','crw','cs','ctr','ctxc','cvc','d','dai','dash','dat','data','dbc','dcn','dcr','deez','dent','dew','dgb','dgd','dlt','dnt','dock','doge','dot','drgn','drop','dta','dth','dtr','ebst','eca','edg','edo','edoge','ela','elec','elf','elix','ella','emb','emc','emc2','eng','enj','entrp','eon','eop','eos','eqli','equa','etc','eth','ethos','etn','etp','eur','evx','exmo','exp','fair','fct','fil','fjc','fldc','flo','flux','fsn','ftc','fuel','fun','game','gas','gbp','gbx','gbyte','generic','gin','glxt','gmr','gno','gnt','gold','grc','grin','grs','grt','gsc','gto','gup','gusd','gvt','gxs','gzr','hight','hns','hodl','hot','hpb','hsr','ht','html','huc','husd','hush','icn','icp','icx','ignis','ilk','ink','ins','ion','iop','iost','iotx','iq','itc','jnt','jpy','kcs','kin','klown','kmd','knc','krb','ksm','lbc','lend','leo','link','lkk','loom','lpt','lrc','lsk','ltc','lun','maid','mana','matic','max','mcap','mco','mda','mds','med','meetone','mft','miota','mith','mkr','mln','mnx','mnz','moac','mod','mona','msr','mth','mtl','music','mzc','nano','nas','nav','ncash','ndz','nebl','neo','neos','neu','nexo','ngc','nio','nkn','nlc2','nlg','nmc','nmr','npxs','ntbc','nuls','nxs','nxt','oax','ok','omg','omni','one','ong','ont','oot','ost','ox','oxt','part','pasc','pasl','pax','paxg','pay','payx','pink','pirl','pivx','plr','poa','poe','polis','poly','pot','powr','ppc','ppp','ppt','pre','prl','pungo','pura','qash','qiwi','qlc','qrl','qsp','qtum','r','rads','rap','rcn','rdd','rdn','ren','rep','repv2','req','rhoc','ric','rise','rlc','rpx','rub','rvn','ryo','safe','safemoon','sai','salt','san','sand','sbd','sberbank','sc','shift','sib','sin','skl','sky','slr','sls','smart','sngls','snm','snt','snx','soc','sol','spacehbit','spank','sphtx','srn','stak','start','steem','storj','storm','stox','stq','strat','stx','sub','sumo','sushi','sys','taas','tau','tbx','tel','ten','tern','tgch','theta','tix','tkn','tks','tnb','tnc','tnt','tomo','tpay','trig','trtl','trx','tusd','tzc','ubq','uma','uni','unity','usd','usdc','usdt','utk','veri','vet','via','vib','vibe','vivo','vrc','vrsc','vtc','vtho','wabi','wan','waves','wax','wbtc','wgr','wicc','wings','wpr','wtc','x','xas','xbc','xbp','xby','xcp','xdn','xem','xin','xlm','xmcc','xmg','xmo','xmr','xmy','xp','xpa','xpm','xpr','xrp','xsg','xtz','xuc','xvc','xvg','xzc','yfi','yoyow','zcl','zec','zel','zen','zest','zil','zilla','zrx'];

/**
 * Parse a token URI into variables we may need.
 *
 * @param uri
 * @returns {{sourceId, typeId, amount, tokenId, depositTime, status}}
 * @constructor
 */
export function UriToToken (uri) {
    let token, tokenId, passTypeId, cost, maxTotal, count, status = 1;
    let parts = uri.split('/');
    if (parts.length) {
        token = parts[parts.length - 1];
        [tokenId, passTypeId, cost, maxTotal, count] = token.split('.');
        tokenId = parseInt(tokenId);
        maxTotal = parseInt(maxTotal);
        count = parseInt(count);
    }
    return {tokenId, passTypeId, cost, maxTotal, count, status, token, uri};
}

/**
 * Parse multiple token URIs into an array of tokens, keyed by ID.
 *
 * @param uris
 * @returns {{}}
 * @constructor
 */
export function UrisToTokens (uris) {
    let tokens = [];

    if (uris !== null) {
        for (let i = 0; i < uris.length; i++) {
            if (typeof uris[i] !== 'string' || uris[i].length === 0) {
                continue;
            }
            tokens.push(UriToToken(uris[i]));
        }
    }

    return tokens;
}

export function tokensToString (tokens) {
    let tokenStrings = [];
    for (let i = 0; i < tokens.length; i++) {
        tokenStrings.push(tokens[i].token);
    }

    return tokenStrings.join(',');
}

/**
 * Render a demo token for a specific fund
 *
 * @param typeId
 * @param tokenId
 * @returns {{sourceId: number, typeId, amount: number, tokenId, depositTime:
 *     number, status: number}}
 * @constructor
 */
export function DemoToken (typeId, tokenId) {
    return UriToToken('https://crocpot.io/token/' +
        Object.values({
            tokenId: tokenId,
            passTypeId: typeId || 0,
            cost: '1000000000000000000',
            maxTotal: 1000,
            count: 421
        }).join('.'));
}

export function DemoTokenSvg(typeId) {
    return 'https://crocpot.io/token/svg/' + [
        0,
        (typeId || 0),
        '1000000000000000000',
        1000,
        990
    ].join('.');
}

/**
 * Given a typeId, get all tokens that apply for current wallet, or fill with a
 * demo token
 *
 * @param typeId
 * @param demoOnly
 * @returns {{demoId: number, tokens: *[]}}
 * @constructor
 */
export function TokensByType (typeId, demoOnly) {
    let tokens = [];
    let demoId = 0;
    typeId = parseInt(typeId);
    demoOnly = demoOnly || false;
    if (!demoOnly && typeof window.tokens !== 'undefined') {
        // Comment out the next 5 lines to only show demo tokens.
        for (let t = 0; t < window.tokens.length; t++) {
            if (window.tokens[t].typeId === typeId) {
                tokens.push(window.tokens[t]);
            }
        }
    }
    if (!tokens.length) {
        // Use a demo token
        demoId++;
        tokens.push(DemoToken(typeId, '0' + demoId));
    }
    else {
        demoId = 1;
        for (let t = 0; t < tokens.length; t++) {
            if (tokens[t].status !== 2) {
                demoId = 0;
                break;
            }
        }
    }
    return {tokens, demoId};
}

/**
 * Get the current token metadata from one or more tokens via the api
 *
 * @param tokens
 * @returns {Promise<*>}
 * @constructor
 */
export async function TokensMeta (tokens) {

    // Default zoom level for just grabbing value.
    const zoom = '1d';

    let tokenStrings = [];
    for (const t in tokens) {
        tokenStrings.push(tokens[t].token);
    }

    const url = [CHART_URL, zoom, tokenStrings.join(',')].join('/');
    console.log('FETCH', url);
    let data = await fetch(url)
        .then(response => response.json());

    return data.meta || {};
}